(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('documentation', {
            parent: 'account',
            url: '/documentation',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Documentation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/documentation/documentation.html',
                    controller: 'DocumentationController',
                    controllerAs: 'vm'
                }
            }
        }).state('documentation.id', {
                parent: 'account',
                url: '/documentation/:id',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Documentation'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/documentation/documentation.html',
                        controller: 'DocumentationController',
                        controllerAs: 'vm'
                    }
                },
                onEnter:  ['$stateParams', '$timeout', '$location', '$anchorScroll', '$document', function($stateParams, $timeout, $location, $anchorScroll, $document)  {
                        $timeout(function() {
                            //$location.hash($stateParams.id);
                            //$anchorScroll();
                            //alert('scroll');
                            var sectionElement = angular.element(document.getElementById($stateParams.id));
                            $document.scrollToElement(sectionElement, 100, 800);
                        }, 500)
                    }]
            });


    }
})();
